/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  table {
    width: 100%;
    border-collapse: collapse;
    min-width: ${({ $minWidth }) => $minWidth || "720px"};
  }
`;

